import { Select, Form, Popover } from "antd";
import { useProductStore } from "./LayoutProducto";
import { Col, Row } from "antd";
import items from "../../api/cuentaAux.json";

const { Option } = Select;

export const ContableItems = () => {
  const producto = useProductStore();
  const listItems = typesProduct;

  function fixEncoding(str = "") {
    // mejora pequeña para ñ/acentos "rotos"
    try {
      /* @ts-ignore */ return decodeURIComponent(escape(str));
    } catch {
      return str.replace(/Ã±/g, "ñ").replace(/Ã‘/g, "Ñ");
    }
  }

  // 🔹 DEDUP: deja solo una fila por número de subcuenta
  const itemsDedup = Array.from(
    new Map(
      items.map((it) => [
        String(it.SubCuentAuxiliarNumero), // clave única
        it, // valor guardado
      ])
    ).values()
  );

  function renderLabel(item) {
    const text = `${item.id} - Parametrización contable para ${item.value}`;
    return (
      <Popover
        content={`${item.id} - Parametrización ${item.value}`}
        placement="top"
      >
        <span>{text.length > 150 ? `${text.substring(0, 20)}...` : text}</span>
      </Popover>
    );
  }

  const groupedItems = listItems.reduce((acc, item, index) => {
    if (index % 2 === 0) acc.push([]);
    acc[acc.length - 1].push(item);
    return acc;
  }, []);

  return groupedItems.map((row, rowIndex) => (
    <Row
      key={rowIndex}
      gutter={[24, 16]}
      style={{ marginLeft: "-12px", marginRight: "-12px" }}
    >
      {row.map((i, colIndex) => (
        <Col key={colIndex} xs={24} lg={12}>
          <Form.Item
            name={`cat${rowIndex * 2 + colIndex}`}
            label={renderLabel(i)}
            rules={[
              { required: true, message: "Selecciona una Categoría ARI contable" },
            ]}
            tooltip={`Cuenta contable para ${i.value}.`}
          >
            <Select
              onChange={(value) =>
                producto.setCategory(rowIndex * 2 + colIndex, value)
              }
              placeholder="Selecciona una Categoría ARI contable"
              allowClear
              showSearch
              style={{ width: "100%" }}
              optionFilterProp="children"
              filterOption={(input, option) =>
                option?.children?.toLowerCase().includes(input.toLowerCase())
              }
              filterSort={(a, b) =>
                a.children.toLowerCase().localeCompare(b.children.toLowerCase())
              }
            >
              {itemsDedup.map((category) => (
                <Option
                  key={String(category.SubCuentAuxiliarNumero)}
                  value={String(category.SubCuentAuxiliarNumero)}
                >
                  {`${category.SubCuentAuxiliarNumero} - ${fixEncoding(
                    category.SubCuentaAuxiliarNombre
                  )}`}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      ))}
    </Row>
  ));
};

// Definición de Categoría ARIs
const typesProduct = [
  { id: 0, value: "Inventario" },
  { id: 1, value: "Ventas" },
  { id: 2, value: "Costo de Ventas" },
  { id: 4, value: "Devolución Compras" },
  { id: 5, value: "Devolución Ventas" },
];
